import { AuthService } from '../services/auth.service';
import { SecurityService } from '../services/security.service';
import { StorageService } from '../services/storage.service';
import { Component, OnInit, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { ChangePasswordComponent } from '../change-password/change-password.component';
import { PreferencesComponent } from '../preferences/preferences.component';
import { ViewContainerRef, Host, ViewChild, HostListener } from '@angular/core';
import { NgForm } from '@angular/forms';
import { RequestOptions } from '@angular/http';
import { NgbTabset } from '@ng-bootstrap/ng-bootstrap';
import { ModalDirective } from 'ngx-bootstrap';

@Component({
	selector: 'app-top-menu',
	templateUrl: './top-menu.component.html',
	styleUrls: ['./top-menu.component.scss']
})
export class TopMenuComponent implements OnInit {

	items = [
		{
			name: 'Dashboard',
			icon: 'glyphicon-shopping-cart',
			goTo: 'dashboard',
			adminOnly: true
		}, {
			name: 'Дела',
			icon: 'glyphicon-shopping-cart',
			goTo: 'cases'
		}, {
			name: 'Лица',
			icon: 'glyphicon-shopping-cart',
			goTo: 'persons'
		}, {
			name: 'Насрочени Дела',
			icon: 'glyphicon-shopping-cart',
			goTo: 'ncases'
		}, {
			name: 'Насрочени Задачи',
			icon: 'glyphicon-shopping-cart',
			goTo: 'nzadachi'
		}, {
			name: 'Моят Календар',
			icon: 'glyphicon-calendar',
			goTo: 'calendar'
		}, {
			name: 'Външни Дела',
			icon: 'glyphicon-folder-open',
			goTo: 'ext-cases'
		}
	];

	@ViewChild('changePasswordModal') changePasswordModal: ChangePasswordComponent;
	@ViewChild('preferencesModal') preferencesModal: PreferencesComponent;

	username = '';
	userColor = '#FFFFFF';

	warningText = '';

	constructor(private zone: NgZone, private authService: AuthService, private securityService: SecurityService, private storageService: StorageService, private router: Router) {
	}

	ngOnInit() {
		const lr = this.storageService.getLoginResponse();
		if (lr && lr.color) {
			this.userColor = lr.color;
		}
	}

	isUserLogged() {
		const loggedIn = this.authService.loggedIn();

		if (loggedIn) {
			this.username = this.authService.getUserName();
			const lr = this.storageService.getLoginResponse();
			if (lr && lr.color) {
				this.userColor = lr.color;
			}
		}

		return loggedIn;
	}

	isUserAdmin(): boolean {
		return this.authService.isUserAdmin();
	}

	/** Менютата без adminOnly за всички; adminOnly само за админ. */
	get visibleItems() {
		const admin = this.isUserAdmin();
		return this.items.filter(i => !i['adminOnly'] || admin);
	}

	logOut() {
		this.authService.logout();
		
		// Redirect
		this.router.navigateByUrl('/login');
	}

	userMenuOpen = false;

	toggleUserMenu(event: MouseEvent) {
		event.stopPropagation();        // да не затвори веднага от document:click
		this.userMenuOpen = !this.userMenuOpen;
	}

	@HostListener('document:click')
	closeMenuOnOutsideClick() {
		this.userMenuOpen = false;
	}

	onChangePassword() {
		this.userMenuOpen = false;
		if (this.changePasswordModal) {
			this.changePasswordModal.show();
		}
	}

	onLogout() {
		this.userMenuOpen = false;
		this.logOut();
	}

	onAdmin() {
		this.userMenuOpen = false;
		this.router.navigate(['/admin']);
	}

	onPreferences() {
		this.userMenuOpen = false;
		if (this.preferencesModal) {
			this.preferencesModal.show();
		}
	}


}